import { COLOR, line, period } from '../../specs'
import type { IndicatorDef } from '../../types'

const def: IndicatorDef = {
  id: 'MIDPRICE',
  version: 1,
  label: 'Midprice',
  pane: 'main',
  category: 'trend',
  series: 'price',
  order: 38,
  inputs: [period('timeperiod', 14)],
  outputs: [line('midprice', 'Midprice', COLOR.blue)],
  talib: { functions: ['MIDPRICE'], expr: 'MIDPRICE(high, low, timeperiod={timeperiod})' },
  listed: true,
  tailSafe: true,
  lookback: ({ timeperiod }) => timeperiod - 1,
}
export default def
